import React from 'react'
import { Text, View } from 'styles/reactnative'
import { CImage } from 'app/components/Common'
import { COLORS } from 'app/constants'
import { DepositCoinListWrapper } from '../../styles'
import { useFetcherPublic } from '../../../../hooks/fetcher'
import { useDepositStore } from '../../../../hooks/deposit/store'

const DepositCoinLists = ({ setModal }) => {
	const { data: res } = useFetcherPublic('/exchanges/coins')

	// eslint-disable-next-line eqeqeq
	const data = res?.result?.result?.filter((item: any) => item.deposit == 1)

	const { data: depositStore } = useDepositStore({
		network: 'TRC20',
		coin: 'USDT',
	})

	return (
		<DepositCoinListWrapper>
			<View
				style={{
					alignItems: 'flex-start',
					justifyContent: 'space-between',
					width: '100%',
					height: '100%',
				}}>
				{data?.map((item: any, index) => (
					<View
						key={index.toString()}
						onClick={() => {
							depositStore.coin = item?.symbol
							setModal(true)
						}}
						style={{
							flexDirection: 'row',
							justifyContent: 'space-between',
							width: '100%',
							padding: 5,
							cursor: 'pointer',
						}}>
						<View style={{ flexDirection: 'row' }}>
							<CImage
								src={`${item?.image}`}
								alt="logo"
								width={20}
								height={20}
								resizeMode={'cover'}
								style={{}}
							/>
							<Text
								size={14}
								style={{
									marginLeft: 5,
									color: COLORS.lightGray,
								}}>
								{item?.symbol}
							</Text>
						</View>
						<Text size={14} style={{ color: COLORS.lightGray }}>
							{item?.name}
						</Text>
					</View>
				))}
			</View>
		</DepositCoinListWrapper>
	)
}

export default DepositCoinLists
